import React from 'react'

import { useGetEntityParamsFromUrl } from '@/componentHelpers/ci'
import { KRISDocumentListContainer } from '@/components/containers/KRISDocumentListContainer'
import { KRISDocumentsTab } from '@/components/views/documents/KRISDocumentsTab'

const KRISDocumentsListPage: React.FC = () => {
    const { entityId } = useGetEntityParamsFromUrl()

    return (
        <KRISDocumentListContainer
            configurationItemId={entityId}
            View={(props) => {
                return <KRISDocumentsTab {...props} />
            }}
        />
    )
}

export default KRISDocumentsListPage
